import React, { CSSProperties } from 'react';
import { Theme, withStyles, createStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

interface CustomTabProps {
  label: string;
}

export const CustomTab = withStyles(({ typography, spacing, palette }: Theme) =>
  createStyles({
    root: {
      fontWeight: typography.fontWeightRegular,
      textTransform: 'capitalize',
      marginRight: spacing(1),
      minWidth: 140,
      paddingTop: spacing(2.6),
      paddingBottom: spacing(2.6),
      lineHeight: 1,
    },
    selected: {
      color: palette.primary.main,
      fontWeight: typography.fontWeightBold,
    },
  })
)((customTabProps: CustomTabProps & { style: CSSProperties }) => (
  <Tab disableRipple {...customTabProps} />
));

export default CustomTab;
